<a class="dialog-link" [attr.href]="href" [attr.download]="download" target="_self">
    <div class="label" [ngClass]="{
        'danger-text': danger,
        'wide-text': href && download,
    }">
        {{ subtitle }}
    </div>
    <div class="flex">
        @if (value) {
            <div class="value">{{ value }}</div>
        }
        <img class="rotate" ngSrc="/assets/img/icons/black-arrow.svg"
             priority="true"
             width="24" height="24"
             alt=""/>
    </div>
</a>

